import { render, staticRenderFns } from "./EstadoDocumentoPage.vue?vue&type=template&id=6d3cb5de"
import script from "./EstadoDocumentoPage.js?vue&type=script&lang=js&external"
export * from "./EstadoDocumentoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports